// removed by extract-text-webpack-plugin
module.exports = {"cont":"PageButton__cont___zW04f","black":"PageButton__black___2quRZ","white":"PageButton__white___2n8Vw","left":"PageButton__left___17Kua","swoop":"PageButton__swoop___J7M_X"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/PageButton/PageButton.css
// module id = 748
// module chunks = 0